var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ComponentDataSchema } from "./components/types.js";
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
import { SpawnSchema } from "./components/entity/Spawn.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let DestroyOnTimeoutSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "timeElapsed");
    __publicField(this, "timeout");
    __publicField(this, "component");
    __publicField(this, "spawnOnTimeout");
    __publicField(this, "applyOnTimeout");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], DestroyOnTimeoutSchema.prototype, "timeElapsed", 2);
__decorateClass([
  type("number"),
  defaultValue(1e3)
], DestroyOnTimeoutSchema.prototype, "timeout", 2);
__decorateClass([
  type("string"),
  defaultValue("")
], DestroyOnTimeoutSchema.prototype, "component", 2);
__decorateClass([
  type([SpawnSchema]),
  defaultValue([])
], DestroyOnTimeoutSchema.prototype, "spawnOnTimeout", 2);
__decorateClass([
  type([ComponentDataSchema]),
  defaultValue([])
], DestroyOnTimeoutSchema.prototype, "applyOnTimeout", 2);
DestroyOnTimeoutSchema = __decorateClass([
  Component("DestroyOnTimeout")
], DestroyOnTimeoutSchema);
let MultiDestroyOnTimeoutSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "timeouts");
  }
};
__decorateClass([
  type([DestroyOnTimeoutSchema]),
  defaultValue([])
], MultiDestroyOnTimeoutSchema.prototype, "timeouts", 2);
MultiDestroyOnTimeoutSchema = __decorateClass([
  Component("MultiDestroyOnTimeout")
], MultiDestroyOnTimeoutSchema);
const __vite_glob_0_32 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DestroyOnTimeoutSchema() {
    return DestroyOnTimeoutSchema;
  },
  get MultiDestroyOnTimeoutSchema() {
    return MultiDestroyOnTimeoutSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  DestroyOnTimeoutSchema as D,
  MultiDestroyOnTimeoutSchema as M,
  __vite_glob_0_32 as _
};
//# sourceMappingURL=DestroyOnTimeoutComponent-72b9efed.js.map
